import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// Packages
import clsx from 'clsx';
import Select from 'react-select';
import PropTypes from 'prop-types';

const SelectButton = (props) => {
  const { label, options, name, value, onChange, loading, disable, icon, orgFilter, optFilter } = props;

	const { global_data } = useSelector(state => state.global);

  const [selectOptions, setSelectOptions] = useState([]);

  useEffect(() => {
    let optsArray = [];

    options.forEach((opt) => {
			if (opt === null || opt === undefined) return;
			if (!opt._id && !opt.value && !opt.name) return;

      let obj = {};
      obj.value = opt._id !== undefined ? opt._id.$oid : opt.value;

      // Determinar el label según el tipo de selector
      if (name === 'submodule') {
        obj.label = opt.title;
      } else if (name === 'route') {
        obj.label = opt.code || opt.name;
      } else {
        obj.label = opt.name;
      }

      optsArray.push(obj);
    });

    if (!orgFilter && !optFilter) {
      const groupedOptions = [
        {
          label: `${global_data?.overview?.[`${name}sQty`]} ${optsArray.length}`,
          options: optsArray
        }
      ];
      setSelectOptions(groupedOptions);
    }
    else {
      setSelectOptions(optsArray);
    }

  }, [options]);

  return (
    <div className={clsx('mb-2', {
      'col-lg-2 col-md-12 col-sm-12': !orgFilter,
      'col-lg-4 col-md-12 col-sm-12': orgFilter || optFilter,
    })}>
      <div className='d-flex row align-items-center'>
        <div className={clsx('text-center', {
          'col-lg-3 col-md-3 col-sm-12': !orgFilter,
          'col-lg-12 col-md-12 col-sm-12': orgFilter
        })}>
          <i className={`bi bi-${icon}`}></i>
          <label htmlFor='staticEmail2'>&nbsp;&nbsp;{label}</label>
        </div>
        
        <div className={clsx({
          'col-lg-9 col-md-9 col-sm-12': !orgFilter,
          'col-lg-12 col-md-12 col-sm-12': orgFilter
        })}>
          <Select
            classNamePrefix='select'
            placeholder={global_data?.utils?.selectButtonPlaceholder}
            noOptionsMessage={() => global_data?.utils?.selectButtonNoOptsMsg}
            maxMenuHeight={170}
            options={selectOptions}
            name={name}
            value={value !== null
              ? selectOptions.flatMap(g => g.options || [g]).find(opt => opt.value === value) ?? null
              : null}
            onChange={(e) => onChange(e, name)}
            isDisabled={disable}
            isClearable={true}
            isSearchable={true}
            isLoading={loading}
          />
        </div>
      </div>
    </div>
  );
}

SelectButton.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disable: PropTypes.bool.isRequired,
  icon: PropTypes.string,
  orgFilter: PropTypes.bool.isRequired,
  optFilter: PropTypes.bool
};

export default SelectButton;